import { Market } from 'BrokerTsLib/src/enums'
import type { IPartnerSettings } from '.'

const hosts = [
  'broker-new.cebia.cz'
  , 'broker.cebia.cz'
  // , 'localhost:44470'
]

export const BusinessLease: IPartnerSettings = {
  partner: 'BusinessLease',
  hosts: hosts,
  market: Market.CZ
}
